import React, { useEffect, useState } from "react";
import { Button, Row } from "react-bootstrap";
import Card from "src/components/Cards/Basic";
import FabPlateau from "src/components/UiComponents/Buttons/FabPlateau";
import IconButton from "src/components/IconButton";
import { dateFormatter } from "src/global";
import {
  faAdd,
  faPencil as PencilIcon,
  faTrash as DeleteIcon,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useModal from "src/components/Modal/hooks/useModal";
import ConfirmDeleteDialog from "src/components/Modal/ConfirmDelete";
import EditSeasonDialog from "./EditSeasonDialog";
import {
  showErrorToast,
  showSuccessToast,
  showValidationErrorToast,
} from "src/components/Toasts";
import axios from "src/config/axios";
import { useTranslation } from "react-i18next";

const SeasonsSettingsPage = ({}) => {
  function handleEdit(season) {
    setSelectedSeason(season);
    toggleEdit();
  }

  function handleArchive(season) {
    setSelectedSeason(season);
    toggleArchive();
  }

  function handleCreate() {
    setSelectedSeason({});
    toggleEdit();
  }
  const [seasons, setSeasons] = useState([]);
  const [selectedSeason, setSelectedSeason] = useState({});
  const { isShow: showEdit, toggle: toggleEdit } = useModal();
  const { isShow: showArchive, toggle: toggleArchive } = useModal();
  const { t } = useTranslation("dashboard");

  useEffect(() => {
    fetchSeasons();
  }, []);

  const fetchSeasons = () => {
    axios
      .get(`/api/v1/seasons.json`)
      .then(function (response) {
        setSeasons(response.data.entries);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const archive = (season) => {
    axios
      .delete(`/api/v1/seasons/${season.id}.json`)
      .then(function () {
        showSuccessToast();
        fetchSeasons();
      })
      .catch(function (error) {
        showValidationErrorToast(error);
      });
  };

  const handleEdited = () => {
    showSuccessToast();
    fetchSeasons();
  };

  const handleDelete = () => {
    archive(selectedSeason);
    toggleArchive();
  };

  return (
    <>
      <Card title={`Saisonen (${seasons.length ?? 0})`}>
        <div className="table-responsive">
          <div className="ui-table-container">
            <table
              className="table table-bordered"
              id="dataTable"
              width="100%"
              cellSpacing="0"
            >
              <thead>
                <tr>
                  <th>Jahr</th>
                  <th>Name</th>
                  <th>Von</th>
                  <th>Bis</th>
                  <th>Optionen</th>
                </tr>
              </thead>
              <tbody>
                {seasons.map((season) => {
                  return (
                    <tr key={season.id}>
                      <td>{season.year}</td>
                      <td>{season.name}</td>
                      <td>{season.from && dateFormatter(season.from)}</td>
                      <td>{season.to && dateFormatter(season.to)}</td>
                      <td>
                        <IconButton
                          className="mr-1 bg-transparent border-0 mr-3"
                          textColor="var(--primary)"
                          icon={PencilIcon}
                          onClick={() => handleEdit(season)}
                        />
                        <IconButton
                          className="mr-2 mr-3 bg-transparent border-0"
                          textColor="var(--danger)"
                          icon={DeleteIcon}
                          onClick={() => handleArchive(season)}
                        />
                      </td>
                    </tr>
                  );
                })}
                {seasons.length === 0 && (
                  <tr>
                    <td>{t("common:components.table.noEntries")}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <Row className="justify-content-end mr-2 mt-5">
          <FabPlateau>
            <Button
              className="float-right p-2 pl-3 pr-3"
              variant="primary"
              onClick={handleCreate}
            >
              <FontAwesomeIcon icon={faAdd} />{" "}
              {t("common:components.button.new")}
            </Button>
          </FabPlateau>
        </Row>
      </Card>
      <EditSeasonDialog
        show={showEdit}
        toggle={toggleEdit}
        season={selectedSeason}
        handleSuccess={handleEdited}
      />
      <ConfirmDeleteDialog
        show={showArchive}
        handleClose={toggleArchive}
        handleDelete={handleDelete}
      />
    </>
  );
};

export default SeasonsSettingsPage;
